interface isa_introEN {
  intro_title: string;
  intro_desc: string;
}

export const isa_introEN: isa_introEN = {
  intro_title: "WHAT IS THE IMPETUS SELECTION ASSESSMENT?",
  intro_desc:
    "The impetus selection assessment is a tool to help identify the impetus that best aligns with your business expectations and goals.",
};

interface isa_videoEN {
  cookies_desc: string;
  button_desc: string;
}

export const isa_videoEN: isa_videoEN = {
  cookies_desc:
    "Please accept our cookies to watch the demonstration video here or watch the video on our channel.",
  button_desc: "Watch the video on YouTube",
};

interface isa_instructEN {
  ins_title: string;
  ins_desc: string;
  ins_sub_title_1: string;
  ins_sub_desc_1: string;
  ins_sub_title_2: string;
  ins_sub_desc_2: string;
  ins_sub_title_3: string;
  ins_sub_desc_3_1: string;
  ins_sub_desc_3_2: string;
  ins_sub_title_4: string;
  ins_sub_desc_4_1: string;
  ins_sub_desc_4_2: string;
  ins_sub_desc_4_3: string;

  ins_video_title: string;
  ins_video_message: string;
  ins_video_button: string;
}

export const isa_instructEN: isa_instructEN = {
  ins_title: "INSTRUCTIONS",
  ins_desc:
    "This tool utilizes a series of questions to know the importance of certain procedures in your business and the changes you are willing to make to enhance your business. To accurately know the results of the impetus selection assessment, it’s important to answer according to the situation of your business.",
  ins_sub_title_1: "Expectations and effort",
  ins_sub_desc_1:
    "Once you start the tool you will see two sections. The first section is a horizontal bar graph that will show the status of the four impetus in your business. This graph will automatically change according to the answers given in the second section.",
  ins_sub_title_2: "Questions for your impetus",
  ins_sub_desc_2:
    "The second section contains the questions that must be answered to get the results of the impetus selection assessment, each question is answered with one of the three answer options shown below the questions. If it is required, it’s also possible to give a short explanation to each answer with the input box located below the answer options.",
  ins_sub_title_3: "Helpful information",
  ins_sub_desc_3_1:
    "Some questions show additional information that may help to understand them; to see this additional information you need to select the “additional info” button that will show a text bubble with said information.",
  ins_sub_desc_3_2:
    "If you wish to redo the questions, select the “reset questions” button to start from the first question. To proceed to the next question, it’s necessary to answer the current question and select the “next” button.",
  ins_sub_title_4: "Get the results from the tool",
  ins_sub_desc_4_1:
    "Once all the questions had been answered, the tool will show the completed graph as a result, this final graph will tell which impetus you are looking to enhance your business and which impetus you are setting your efforts to improve your business.",
  ins_sub_desc_4_2:
    "The tool now shows two options, one of the options is the “reset” button previously mentioned and the other option is the “get results” button, this option shows a section for you to provide the email that will receive the results of this tool.",
  ins_sub_desc_4_3:
    "The results will be sent to the given email in a PDF format (this PDF will contain the final graph and the answered questions with their respective comments if there were any).",

  ins_video_title:
    "If you need help understanding this tool, here is a demonstration video:",
  ins_video_message:
    "Once you are ready to start the impetus selection assessment please select the button below.",
  ins_video_button: "Start the tool",
};

interface isa_messageEN {
  message_title: string;
  message_desc: string;
}

export const isa_messageEN: isa_messageEN = {
  message_title: "IMPETUS SELECTION ASSESSMENT",
  message_desc:
    "Please select your answer according to the criteria of your business:",
};

interface isa_graphEN {
  data_label_1: string;
  data_label_2: string;
  data_label_3: string;
  data_label_4: string;
  data_label_5: string;
  data_label_6: string;
  data_label_7: string;
  data_set_1: string;
  data_set_2: string;

  qstn_1: string;
  qstn_2: string;
  qstn_3: string;
  qstn_4: string;
  qstn_5: string;
  qstn_6: string;
  qstn_7: string;
  qstn_8: string;
  qstn_9: string;
  qstn_10: string;
  qstn_11: string;
  qstn_12: string;
  qstn_13: string;
  qstn_14: string;
  qstn_15: string;
  qstn_16: string;
  qstn_17: string;
  qstn_18: string;
  qstn_19: string;
  qstn_20: string;
  qstn_21: string;
  qstn_22: string;
  qstn_23: string;

  as1_1: string;
  as1_2: string;
  as1_3: string;
  as1_4: string;
  as1_5: string;
  as1_6: string;
  as1_7: string;
  as1_8: string;
  as1_9: string;
  as1_10: string;
  as1_11: string;
  as1_12: string;
  as1_13: string;
  as1_14: string;
  as1_15: string;
  as1_16: string;
  as1_17: string;
  as1_18: string;
  as1_19: string;
  as1_20: string;
  as1_21: string;
  as1_22: string;

  as2_1: string;
  as2_2: string;
  as2_3: string;
  as2_4: string;
  as2_5: string;
  as2_6: string;
  as2_7: string;
  as2_8: string;
  as2_9: string;
  as2_10: string;
  as2_11: string;
  as2_12: string;
  as2_13: string;
  as2_14: string;
  as2_15: string;
  as2_16: string;
  as2_17: string;
  as2_18: string;
  as2_19: string;
  as2_20: string;
  as2_21: string;
  as2_22: string;

  as3_1: string;
  as3_2: string;
  as3_3: string;
  as3_4: string;
  as3_5: string;
  as3_6: string;
  as3_7: string;
  as3_8: string;
  as3_9: string;
  as3_10: string;
  as3_11: string;
  as3_12: string;
  as3_13: string;
  as3_14: string;
  as3_15: string;
  as3_16: string;
  as3_17: string;
  as3_18: string;
  as3_19: string;
  as3_20: string;
  as3_21: string;
  as3_22: string;

  addinfo_1: string;
  addinfo_2: string;
  addinfo_3: string;
  addinfo_4: string;
  addinfo_5: string;
  addinfo_6: string;
  addinfo_7: string;

  button_reset: string;
  modal_question_reset: string;
  modal_question_reset_yes: string;
  modal_question_reset_no: string;

  question_index_1: string;
  question_index_2: string;

  text_area: string;
  button_previous: string;
  button_next: string;
  button_additional: string;
  button_results: string;
  no_comment: string;
  pdf_question_index_1: string;
  pdf_question_index_2: string;
  pdf_answer: string;
  pdf_comments: string;
  error_email_1: string;
  error_email_2: string;
  error_name: string;
  error_last_name: string;
  error_phone_1: string;
  error_phone_2: string;

  graph_title: string;

  modal_email_title: string;
  modal_email_desc: string;
  modal_email_label: string;
  modal_email: string;
  modal_name_label: string;
  modal_name: string;
  modal_last_name_label: string;
  modal_last_name: string;
  modal_phone_number_label: string;
  modal_phone_number: string;
  modal_email_send: string;
  wait_email_title: string;
  wait_email: string;
  success_email_title: string;
  success_email: string;
  success_understood: string;
  error_email_title: string;
  error_email: string;
  error_understood: string;
}

export const isa_graphEN: isa_graphEN = {
  data_label_1: "DAILY",
  data_label_2: "MANAGEMENT",
  data_label_3: "CONTINUOUS",
  data_label_4: "IMPROVEMENT",
  data_label_5: "BUSINESS",
  data_label_6: "TRANSFORMATION",
  data_label_7: "INNOVATION",
  data_set_1: "EFFORT",
  data_set_2: "EXPECTATIONS",

  qstn_1: "How important are financial benefits for your business?",
  qstn_2: "How important are visible improvements for your business?",
  qstn_3:
    "How important is it that customers feel the improvements for your business?",
  qstn_4:
    "How important is it to increase employee engagement for your business?",
  qstn_5:
    "How important is it to develop a customer focused culture for your business?",
  qstn_6:
    "How important is it to improve leadership involvement for your business?",
  qstn_7: "How fast do you want to see the improvements?",
  qstn_8: "Are you willing to make new tasks for your business?",
  qstn_9: "Are you willing to take on new responsibilities for your business?",
  qstn_10: "Are you willing to make new roles for your business?",
  qstn_11:
    "Are you willing to do a local workplace relocation for your business?",
  qstn_12:
    "Are you willing to make structural reporting changes for your business?",
  qstn_13:
    "Is the leadership team of your business willing to provide guidance and/or input?",
  qstn_14:
    "Is the leadership team of your business willing to show new behavior?",
  qstn_15:
    "Is the leadership team of your business willing to show active involvement and commitment to results?",
  qstn_16:
    "Are you willing to do technological changes for your business like purchasing over-the-counter equipment?",
  qstn_17:
    "Are you willing to do technological changes for your business like developing new reports and/or interphases?",
  qstn_18:
    "Are you willing to do technological changes for your business like changing current systems and /or equipment?",
  qstn_19:
    "Are you willing to do technological changes like developing new systems and /or equipment?",
  qstn_20:
    "Are you willing to take risks for your business like unpredictable results?",
  qstn_21:
    "Are you willing to take risks for your business like making non-reversible changes?",
  qstn_22:
    "Are you willing to take risks for your business like making medium/high capital investments?",
  qstn_23: "The parameters have been completed, here are the results.",

  as1_1: "Not that important",
  as1_2: "Not that important",
  as1_3: "Not that important",
  as1_4: "Not that important",
  as1_5: "Not that important",
  as1_6: "Not that important",
  as1_7: "Years (1-4)",
  as1_8: "Definitely not",
  as1_9: "Definitely not",
  as1_10: "Definitely not",
  as1_11: "Definitely not",
  as1_12: "Definitely not",
  as1_13: "Definitely not",
  as1_14: "Definitely not",
  as1_15: "Definitely not",
  as1_16: "Definitely not",
  as1_17: "Definitely not",
  as1_18: "Definitely not",
  as1_19: "Definitely not",
  as1_20: "Definitely not",
  as1_21: "Definitely not",
  as1_22: "Definitely not",

  as2_1: "Important",
  as2_2: "Important",
  as2_3: "Important",
  as2_4: "Important",
  as2_5: "Important",
  as2_6: "Important",
  as2_7: "Months (9-14)",
  as2_8: "Only if we have to but we will look for shortcuts first",
  as2_9: "Only if we have to but we will look for shortcuts first",
  as2_10: "Only if we have to but we will look for shortcuts first",
  as2_11: "Only if we have to but we will look for shortcuts first",
  as2_12: "Only if we have to but we will look for shortcuts first",
  as2_13: "Only if we have to but we will look for shortcuts first",
  as2_14: "Only if we have to but we will look for shortcuts first",
  as2_15: "Only if we have to but we will look for shortcuts first",
  as2_16: "Only if we have to but we will look for shortcuts first",
  as2_17: "Only if we have to but we will look for shortcuts first",
  as2_18: "Only if we have to but we will look for shortcuts first",
  as2_19: "Only if we have to but we will look for shortcuts first",
  as2_20: "Only if we have to but we will look for shortcuts first",
  as2_21: "Only if we have to but we will look for shortcuts first",
  as2_22: "Only if we have to but we will look for shortcuts first",

  as3_1: "Very important",
  as3_2: "Very important",
  as3_3: "Very important",
  as3_4: "Very important",
  as3_5: "Very important",
  as3_6: "Very important",
  as3_7: "Weeks (12-24)",
  as3_8: "We want to do this right, so this will get done as it should be",
  as3_9: "We want to do this right, so this will get done as it should be",
  as3_10: "We want to do this right, so this will get done as it should be",
  as3_11: "We want to do this right, so this will get done as it should be",
  as3_12: "We want to do this right, so this will get done as it should be",
  as3_13: "We want to do this right, so this will get done as it should be",
  as3_14: "We want to do this right, so this will get done as it should be",
  as3_15: "We want to do this right, so this will get done as it should be",
  as3_16: "We want to do this right, so this will get done as it should be",
  as3_17: "We want to do this right, so this will get done as it should be",
  as3_18: "We want to do this right, so this will get done as it should be",
  as3_19: "We want to do this right, so this will get done as it should be",
  as3_20: "We want to do this right, so this will get done as it should be",
  as3_21: "We want to do this right, so this will get done as it should be",
  as3_22: "We want to do this right, so this will get done as it should be",

  addinfo_1: "Hard savings with impact on the budget.",
  addinfo_2:
    "Bold process changes that significantly enhance process performance.",
  addinfo_3:
    "Customers clearly perceived lead time, quality and/or cost improvements.",
  addinfo_4:
    "Measured as ownership and involvement in solving improvement opportunities.",
  addinfo_5:
    "A culture where external customer satisfaction is the main factor in the decision making process.",
  addinfo_6:
    "Develop a people-based, results-oriented leadership environment with bias towards action.",
  addinfo_7:
    "Waiting time to perceive the improvements, from a few weeks to more than a year.",

  button_reset: "Reset questions",
  modal_question_reset: "Do you wish to reset all the questions?",
  modal_question_reset_yes: "Yes",
  modal_question_reset_no: "No",
  question_index_1: "Question",
  question_index_2: "of",

  text_area: "Explanation for the answers (optional)",
  button_additional: "Additional info",
  button_previous: "Previous",
  button_next: "Next",
  button_results: "Get results",
  no_comment: "No comment",
  pdf_question_index_1: "Question ",
  pdf_question_index_2: " of ",
  pdf_answer: "Your Answer:",
  pdf_comments: "Your Comments:",
  error_email_1: "Please enter your email.",
  error_email_2: "Please enter a valid email address.",
  error_name: "Please enter your name.",
  error_last_name: "Please enter your last name.",
  error_phone_1: "Please enter your phone number.",
  error_phone_2: "Phone number must be at least 10 characters long.",

  graph_title: "EXPECTATIONS AND EFFORT",

  modal_email_title: "Share contact info",
  modal_email_desc: "Share your contact info for the results",
  modal_email_label: "EMAIL:",
  modal_email: "Email address",

  modal_name_label: "NAME:",
  modal_name: "Name",
  modal_last_name_label: "LAST NAME:",
  modal_last_name: "Last name",
  modal_phone_number_label: "PHONE NUMBER:",
  modal_phone_number: "Phone number",

  modal_email_send: "Send results",
  wait_email_title: "Please wait a moment",
  wait_email: "Generating PDF and email message...",
  success_email_title: "Email sent",
  success_email: "Your results were sent via email",
  success_understood: "Understood",
  error_email_title: "Oops! Something went wrong",
  error_email: "An error has ocurred, please try again",
  error_understood: "Understood",
};
